import { api } from "../../../Api";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getCablesThunk = createAsyncThunk('cable/getCables', async (data) => {
    return await api.getCablesById(data)
})

export const getCableTagsThunk = createAsyncThunk('cable/getCableTags', async () => {
    return await api.getCableTags()
})

export const getCablesTableThunk = createAsyncThunk('cable/getCablesTable', async () => {
    return await api.getCablesTable()
})

export const cableBuilder = (builder) => {
    builder.addCase(getCablesThunk.pending, (state) => {
        state.isLoading = true
        state.cables = []
    }).addCase(getCablesThunk.rejected, (state) => {
        state.isLoading = false
        state.error = 'Произошла ошибка при получении кабелей'
        state.cables = []
    }).addCase(getCablesThunk.fulfilled, (state, action) => {
        state.isLoading = false
        state.cables = action.payload.prices
    })

    builder.addCase(getCableTagsThunk.pending, (state) => {
        state.isLoading = true
        state.cablesTags = []
    }).addCase(getCableTagsThunk.rejected, (state) => {
        state.isLoading = false
        state.error = 'Произошла ошибка при получении кабелей'
        state.cablesTags = []
    }).addCase(getCableTagsThunk.fulfilled, (state, action) => {
        state.isLoading = false
        console.log(action.payload);
        
        state.cablesTags = action.payload //action.payload.filter((item, index) => item.alias_id !== null && index === action.payload.findIndex((item2) => item2.alias_id === item.alias_id))
    })

    builder.addCase(getCablesTableThunk.pending, (state) => {
        state.isLoading = true
        state.cablesTable = []
    }).addCase(getCablesTableThunk.rejected, (state) => {
        state.isLoading = false
        state.error = 'Произошла ошибка при получении кабелей'
        state.cablesTable = []
    }).addCase(getCablesTableThunk.fulfilled, (state, action) => {
        state.isLoading = false
        state.cablesTable = action.payload
        state.tableMarketplaceTags = action.payload.map(({marketplace_id, marketplace_name}) => ({marketplace_id, marketplace_name}))
        state.tableAliasTags = action.payload.map(item => item.aliases).flat().filter((item, index, arr) => index === arr.findIndex((item2) => item2.alias_id === item.alias_id))
        state.tableVendorsTags = action.payload.map(item => item.aliases.map( item => item.prices).flat()).flat()
            .filter((item, index, arr) => index === arr.findIndex((item2) => item2.vendor_id === item.vendor_id))
    })
}

